<template>
  <summary-count
    title="Charges this week"
    :is-loading="isLoading"
    :count="charges"
    :change-count="-failedCount"
    changeLabel=" failed this week"
    icon="x"
    @cardClicked="gotoLink()"
  />
</template>

<script>
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";
import moment from "moment";

export default {
  name: "Charges",
  components: {
    SummaryCount,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      charges: 0,
      failedCount: 0,
      isLoading: false,
    };
  },
  computed: {
    startOfWeek() {
      return moment()
        .startOf("week")
        .toDate();
    },
    endOfWeek() {
      return moment()
        .endOf("week")
        .toDate();
    },
  },
  created() {
    this.loadCharges();
  },
  methods: {
    loadCharges() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/dashboard/charges`;

      this.$axios
        .get(url, {
          params: {
            startOfWeek: this.startOfWeek,
            endOfWeek: this.endOfWeek,
          },
        })
        .then((res) => {
          this.charges = res.data.charges;
          this.failedCount = res.data.failedCount;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    gotoLink() {
      this.$router.push(`/businesses/${this.businessId}/reports/charges`);
    },
  },
};
</script>
